import * as React from 'react';
import 'isomorphic-fetch';
import { ImageListEditor } from "../ImageListEditor";
export class AdminSlider extends React.Component {
    constructor() {
        super();
        this.state = { loading: true, mainPageSliderId: -1 };
        fetch('Data/GetMainPageSliderId', { credentials: 'same-origin' })
            .then(response => response.json())
            .then(data => {
            this.setState({ loading: false, mainPageSliderId: data });
        });
    }
    render() {
        let result = React.createElement("div", null);
        if (this.state.loading) {
            result = React.createElement("div", null, "Fetching main page images info...");
        }
        else {
            result = React.createElement("div", null,
                React.createElement(ImageListEditor, { imageListId: this.state.mainPageSliderId }));
        }
        return result;
    }
}
//# sourceMappingURL=AdminSlider.js.map


//////////////////
// WEBPACK FOOTER
// ./ClientApp/AdminSlider/AdminSlider.js
// module id = 87
// module chunks = 0